import styles from './contacte.module.scss';
import Enllac from 'components/corporatiu/Enllac';

export default function Contacte(props) {
    return (
        <article id='contingut' role='main' className='premsa-contacte'>
            <ul className={styles.squareList}>
                <li>
                    <strong>Corporació Catalana de Mitjans Audiovisuals - 3Cat:</strong>{' '}
                    <Enllac href='tel:934444800' className={styles.phone}>
                        93 444 48 00
                    </Enllac>
                </li>
                <li>
                    <strong>Televisió de Catalunya: </strong>{' '}
                    <Enllac href='tel:934999333' className={styles.phone}>
                        93 499 93 33
                    </Enllac>
                </li>
                <li>
                    <strong>Catalunya Ràdio:</strong>{' '}
                    <Enllac href='tel:933069200' className={styles.phone}>
                        93 306 92 00
                    </Enllac>
                </li>
                <li>
                    <strong>Fundació La Marató de 3Cat:</strong>{' '}
                    <Enllac href='tel:934999333' className={styles.phone}>
                        93 499 93 33
                    </Enllac>
                </li>
            </ul>

            <h2>Serveis informatius</h2>
            <h3>TV3</h3>
            <ul className={styles.squareList}>
                <li>
                    <strong>Secció d&apos;Economia:</strong> <span className={styles.correu}>economia@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció de Societat:</strong> <span className={styles.correu}>societat@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció de Cultura:</strong> <span className={styles.correu}>cultura@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció de Política:</strong> <span className={styles.correu}>politica@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció d&apos;Internacional:</strong> <span className={styles.correu}>internacional@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció d&apos;Esports:</strong> <span className={styles.correu}>esports@tv3.cat</span>
                </li>
                <li>
                    <strong>3CatInfo:</strong> <span className={styles.correu}>editors324@3cat.cat</span>
                </li>
                <li>
                    <strong>Meteorologia:</strong> <span className={styles.correu}>meteo@3cat.cat</span>
                </li>
            </ul>

            <h3>Catalunya Ràdio</h3>
            <ul className={styles.squareList}>
                <li>
                    <strong>Secció de Cultura:</strong> <span className={styles.correu}>culturacr@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció de Societat:</strong> <span className={styles.correu}>societatcr@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció d&apos;Internacional:</strong> <span className={styles.correu}>internacionalcr@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció d&apos;Economia:</strong> <span className={styles.correu}>economiacr@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció de Política:</strong> <span className={styles.correu}>politicacr@3cat.cat</span>
                </li>
                <li>
                    <strong>Secció d&apos;Esports:</strong> <span className={styles.correu}>esportscatradio@3cat.cat</span>
                </li>
                <li>
                    <strong>Informatius cap de setmana:</strong>{' '}
                    <span className={styles.correu}>informatiucapdesetmana@3cat.cat</span>
                </li>
                <li>
                    <strong>3CatInfo:</strong> <span className={styles.correu}>producció.cinformacio@3cat.cat</span>
                </li>
            </ul>

            <h3>Delegacions territorials</h3>
            <ul className={styles.squareList}>
                <li>
                    <strong>Delegacions territorials:</strong>{' '}
                    <Enllac href='/corporatiu/ca/on-som/' className={styles.link}>
                        On som?
                    </Enllac>
                </li>
            </ul>

            <h2>Programes</h2>
            <h3>TV3</h3>
            <ul className={styles.squareList}>
                <li>
                    <strong>30 minuts:</strong> <span className={styles.correu}>30minuts@3cat.cat</span>
                </li>
                <li>
                    <strong>Els matins:</strong> <span className={styles.correu}>matinstv3@3cat.cat</span>
                </li>
                <li>
                    <strong>Info K:</strong> <span className={styles.correu}>infok@3cat.cat</span>
                </li>
                <li>
                    <strong>Tot es mou:</strong> <span className={styles.correu}>totesmou@3cat.cat</span>
                </li>
                <li>
                    <strong>La Selva:</strong> <span className={styles.correu}>laselva@3cat.cat</span>
                </li>
                <li>
                    <strong>Nervi:</strong> <span className={styles.correu}>nervi@3cat.cat</span>
                </li>
                <li>
                    <strong>Marcians:</strong> <span className={styles.correu}>marcians@3cat.cat</span>
                </li>
                <li>
                    <strong>La Marató:</strong> <span className={styles.correu}>lamarato@3cat.cat</span>
                </li>
            </ul>

            <h3>Catalunya Ràdio</h3>
            <ul className={styles.squareList}>
                <li>
                    <strong>iCat:</strong> <span className={styles.correu}>icat@icat.cat</span>
                </li>
                <li>
                    <strong>Catalunya Música:</strong> <span className={styles.correu}>info@catmusica.cat</span>
                </li>
                <li>
                    <strong>El matí de Catalunya Ràdio:</strong> <span className={styles.correu}>mati@catradio.cat</span>
                </li>
                <li>
                    <strong>La tarda de Catalunya Ràdio:</strong> <span className={styles.correu}>latarda@catradio.cat</span>
                </li>
                <li>
                    <strong>El suplement:</strong> <span className={styles.correu}>suplement@catradio.cat</span>
                </li>
                <li>
                    <strong>Que no surti d&apos;aquí:</strong> <span className={styles.correu}>quenosurti@3cat.cat</span>
                </li>
                <li>
                    <strong>Programes informatius:</strong> <span className={styles.correu}>bust_infcr@3cat.cat</span>
                </li>
            </ul>

            <h3>Servei d&apos;Atenció a l&apos;Audiència</h3>
            <p>
                El Servei d&apos;Atenció a l&apos;Audiència respon comunicacions relacionades amb la programació, les activitats i
                els serveis dels nostres canals de ràdio, televisió i mitjans digitals.
            </p>
            <ul className={styles.squareList}>
                {' '}
                <li>
                    <strong>Si voleu contactar per telèfon, ho podeu fer al</strong>{' '}
                    <Enllac href='tel:938844488' className={styles.phone}>
                        93 884 44 88
                    </Enllac>
                </li>
                <li>
                    <strong>Servei d&apos;Atenció a l&apos;Audiència:</strong>{' '}
                    <Enllac href='/atencio/' className={styles.link}>
                        3cat.cat/atencio
                    </Enllac>
                </li>
            </ul>
            <h3>Departament de Comunicació</h3>
            <p>
                El Departament de Comunicació de 3Cat atén únicament les consultes dels professionals dels mitjans de comunicació.
            </p>
            <ul className={styles.squareList}>
                <li>
                    <Enllac href='tel:934999333' className={styles.phone}>
                        93 499 9333
                    </Enllac>
                </li>
                <li>
                    <span className={styles.correu}>comunicacio@3cat.cat</span>
                </li>
            </ul>

            <h3>Servei de còpies</h3>
            <ul className={styles.squareList}>
                <li>
                    <strong>Servei de còpies:</strong> <span className={styles.correu}>copies@3cat.cat</span>
                </li>
            </ul>
        </article>
    );
}
